import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import TundukIcon from 'shared/icons/tunduk.svg'
import { onLoadFileInput } from 'shared/lib/load-file'
import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'
import { useDialogBottomSheet } from 'shared/ui/dialog-bottom-sheet/lib'
import { ImageLazy } from 'shared/ui/image-lazy'
import { BlockSelect } from 'shared/ui/select/components/select-block'

import s from './styles.module.scss'

const TypeLoadFile = {
  FILE: 'file',
  TUNDUK: 'tunduk',
}

const ListTypeFile = [
  {
    value: TypeLoadFile.FILE,
    name: 'passport_photo',
    prefix: (
      <AppIcon
        id={AllIcons.LOAD_SCAN_IMG}
        className={s.icon}
      />
    ),
  },
  {
    value: TypeLoadFile.TUNDUK,
    name: 'screenshot_from_tunduk',
    prefix: (
      <ImageLazy
        src={TundukIcon}
        className={s.icon}
      />
    ),
  },
]

interface Props {
  onError?: () => void
  onLoadTunduk?: () => void
  onLoadFile: (file: File) => void
}

export const SelectTypeFile = ({
  onError,
  onLoadFile,
  onLoadTunduk,
}: Props) => {
  const { t } = useTranslation()

  const { closeDialog } = useDialogBottomSheet()

  const onChangeTypeFile = (value: string) => {
    if (value === TypeLoadFile.FILE) {
      onLoadFileInput({
        onLoadFile,
        onError,
      })

      closeDialog()

      return
    }

    if (value === TypeLoadFile.TUNDUK) {
      onLoadTunduk?.()

      return
    }

    onError?.()
  }

  return (
    <div className={s.container}>
      <p className={clsx('extra-bold-20', s.title)}>{t('load_passport')}</p>

      <BlockSelect
        listOption={ListTypeFile?.map((option) => ({
          ...option,
          name: t(option.name),
        }))}
        onChange={({ value }) => onChangeTypeFile(value)}
      />
    </div>
  )
}
